import { call, put, take, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/invite';
import {
  fetchRequest as fetchMembers,
  RESPONSE as MEMBERS_RESPONSE,
  FAILURE as MEMBERS_FAILURE,
} from '../../actions/organizations/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { orgId, email, role } = action.payload;
  try {
    yield call(
      axios.post,
      `${config.API_URL}/organization/${orgId}/invite`,
      { email, role },
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: `Invitation sent to ${email}` });
    // Keep the "Sending…" state until the roster refresh lands, like the
    // old "await reload(orgId)".
    yield put(fetchMembers({ orgId }));
    yield take([MEMBERS_RESPONSE, MEMBERS_FAILURE]);
    yield put(fetchSuccess({ email }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message
      || err?.response?.data?.data?.message
      || 'Could not send invitation';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
